import { Suspense, lazy } from "react";
import CodeSplitLoader from "components/CodeSplitLoader";

const LoginPage = lazy(() => import(/* webpackChunkName: "login" */ "./Login"));

const Login = (props) => (
  <Suspense fallback={<CodeSplitLoader />}>
    <LoginPage {...props} />
  </Suspense>
);

export default Login;
